import { addDoc, collection } from 'firebase/firestore';
import { db } from '../lib/firebase';

interface IpInfo {
  ip: string;
  city?: string;
  region?: string;
  country?: string;
}

export const getIpInfo = async (): Promise<IpInfo> => {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.reason || 'Error getting IP info');
    }

    return {
      ip: data.ip,
      city: data.city,
      region: data.region,
      country: data.country_name
    };
  } catch (error) {
    console.error('Error fetching IP info:', error);
    // Fallback to just IP in case of error
    const ipResponse = await fetch('https://api.ipify.org?format=json');
    const ipData = await ipResponse.json();
    return { ip: ipData.ip };
  }
};

export const recordVote = async (treeId: string, ipInfo: IpInfo) => {
  try {
    await addDoc(collection(db, 'votes'), {
      treeId,
      ip: ipInfo.ip,
      city: ipInfo.city,
      region: ipInfo.region,
      country: ipInfo.country,
      timestamp: new Date(),
      userAgent: navigator.userAgent
    });
  } catch (error) {
    console.error('Error recording vote:', error);
    throw error;
  }
};